@if (event) {
  <div class="event-view-container"  >
    @if (!['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT'].includes(event.type)) {
      <div class="color-indicator">
        <div class="icons">
          <!-- <div class="icon-container" *ngIf="event.fehlendeDolmetscher"> -->
          <!-- <img  -->
          <!-- [src]="'https://assets.tridimo.de/fontawesome/svgs/regular/circle-' + (event.fehlendeDolmetscher || 0) + '.svg'" -->
          <!-- [alt]="'Fehlende Dolmetscher: ' + (event.fehlendeDolmetscher || 0)" -->
          <!-- class="missing-interpreter-icon" -->
          <!-- [title]="'Fehlende Dolmetscher: ' + (event.fehlendeDolmetscher || 0)"> -->
        <!-- </div> -->
        @if (event.dialinTime) {
          <div class="icon-container">
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/circle-quarter-stroke.svg" alt="Einwahlzeit" class="info-icon" title="Einwahlzeit">
          </div>
        }
        @if (event.online) {
          <div class="icon-container" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'online')}" >
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/wifi.svg" alt="Onlinetermin"  title="Onlinetermin" class="info-icon">
          </div>
        }
        @if (event.vorbereitungsmaterial === '1' || event.vorbereitungsmaterial === true) {
          <div class="icon-container" [ngStyle]="{ 'background-color': iconService.getPrepIconBackground(event)}">
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/folder-open.svg" alt="Vorbereitungsmaterial" class="info-icon" title="Vorbereitungsmaterial">
          </div>
        }
        @if (this.missing) {
          <div class="icon-container" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'interpretor')}">
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/user.svg" alt="Fehlender Dolmetscher" class="int-icon"  title="Fehlender Dolmetscher">
          </div>
        }
        @if (!event.online && event.location === '' && ['MISSIONEVENT', 'TEAMEVENT', 'MEETINGEVENT', 'NOTBILLABLEEVENT'].includes(event.type)) {
          <div class="icon-container" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'location')}">
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/map-location-dot.svg" alt="Adresse fehlt" class="info-icon" title="Adresse fehlt">
          </div>
        }
      </div>
    </div>
  }
  <div class="event-content-container" [ngStyle]="colorService.getBackground(event)">
    <!-- Kategorie Reihe -->
    @if (iconService.getCategoryIcon(event.category)) {
      <div class="category-icon">
        <img [src]="iconService.getCategoryIcon(event.category)" alt="{{ event.category }}" title="{{event.category}}" >
      </div>
    }
    @if (event.fehlendeDolmetscher) {
      <div class="missing-int-badge">
        <img
          [src]="'https://assets.tridimo.de/fontawesome/svgs/regular/circle-' + (event.fehlendeDolmetscher || 0) + '.svg'"
          [alt]="'Fehlende Dolmetscher: ' + (event.fehlendeDolmetscher || 0)"
          class="missing-interpreter-icon"
          [title]="'Fehlende Dolmetscher: ' + (event.fehlendeDolmetscher || 0)">
        </div>
      }
      <!-- 1. Reihe -->
      <div>
        @if (!['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT'].includes(event.type)) {
          <span class="event-title">{{ event.title }}</span>
        }
        @if ( event.type === 'MISSIONEVENT') {
          <span class="event-title"> {{ getCustomerNames(event) }}</span>
        }
        <!-- <span *ngIf="!['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT'].includes(event.original.type)" class="event-title">{{ getEventTitle(event) }}</span> -->
      </div>
      @if (['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT'].includes(event.type)) {
        <div class="title-container" class="large-title-container">
          <span  class="event-title-large">{{ event.title }}</span>
        </div>
      }
      <!-- <div *ngIf="event.ticketno" > -->
      <!-- <div *ngIf="event.ticketno">{{ event.ticketno}} - </div> -->
    <!-- </div> -->
    <!-- 2. Reihe -->
    <div class="location">
      @if (event.location) {
        <div class="icon-container3">
          <img src="https://assets.tridimo.de/fontawesome/svgs/regular/map-location-dot.svg" alt="">
          {{ event.location === 'Lina-Bommer-Weg 6, 51149 Köln' ? 'Büro' : event.location }}
        </div>
      }
      @if (event.online) {
        <div class="icon-container3">
          @if (event.minuteBased) {
            <img src="https://assets.tridimo.de/fontawesome/svgs/regular/timer.svg" alt="" title="Minutengenau">
          }
          @if (event.minuteBased && event.onlineLink?.length) {
            <span>-</span>
          }
          @for (item of (event.onlineLink || []); track item; let i = $index) {
            <div class="icon-container3">
              @if (i > 0) {
                <span class="plus-separator">+</span>
              }
              @if (item.platform !== 'online' && item.platform !== 'Link') {
                <img [src]="platformIcons[item.platform]" alt="{{ item.platform }}" title="{{ item.platform }}" class="platform-icon" />
              }
              @if (item.platform === 'online') {
                <span>Online</span>
              }
            </div>
          }
        </div>
      }
    </div>
    <div>
      {{ event.start | date: 'HH:mm' }} - {{ event.end | date: 'HH:mm' }}
    </div>
    <!-- 3. Reihe -->
    @if (event.isTemplate === 0) {
      <div class="id-info-container">
        @if (event.informations) {
          <div class="informations-container">
            @for (icon of (event.informations || []); track icon) {
              @if (icon?.icon_name && icon.icon_name !== 'fremd Dolmetscher') {
                <div class="information-icon">
                  <img
                    [title]="iconService.getIconTitle(icon.icon_name)"
                    [src]="iconService.getIconUrl(icon.icon_name)">
                  </div>
                }
              }
            </div>
          }
          @if ((coData?.length > 0) || fremdData) {
            <div class="row-4">
              <div class="cr-container">
                @for (co of coData || []; track co) {
                  <div class="mini-user-icon" [ngClass]="co.workingType === 'Praktikant' ? 'trainee-mini-icon-color' : ''">
                    @if (co.workingType !== 'Praktikant') {
                      <span [title]="co.name">{{co.cr}}</span>
                    }
                    @if (co.workingType === 'Praktikant') {
                      <span [title]="co.name">P</span>
                    }
                  </div>
                }
                @if (fremdData) {
                  <div title="Fremd Dolmetscher" class="mini-fremd-icon">
                    <span>F</span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}